import _ from 'lodash';

function RecordEtcCtrl($scope, $rootScope, $state, $stateParams, toastr, AuthService, BioService) {
  'ngInject';

  $rootScope.$emit('base:sidebarEvent', false, false);

  const vm = this;
  vm.showDetail = false; // 선수 데이터 입력창 모드
  vm.playersBioInfo = [];
  vm.inputBioInfo = null;
  vm.selectPlayer = null;

  // Player 모드
  if (vm.appContext.user.is_player) {
    vm.showDetail = true;
    vm.selectPlayer = vm.appContext.user;
  }


  vm.healthDataList = function () {
    var params = {
      'login_id': vm.appContext.user.login_id,
      'uuid': vm.appContext.user.uuid,
      // 'date' : $scope.$parent.base.commonData.date,
      'date': '2017.09.19',
    };
    BioService.healthDataList(params).then(function (res) {
      var data = res.data;
      vm.playersBioInfo = data.data;
    });
  }
  vm.healthDataList();

  vm.exitShowDetail = function () {
    // var params = {
    //   'login_id' : $scope.userInfo.login_id,
    //   'uuid' : $scope.userInfo.uuid,
    //   'date' : $scope.$parent.base.commonData.date,
    // };
    // BioService.healthDataList(params).then(function(data){
    //   vm.playersBioInfo = data.data;
    //   vm.selectBioData = vm.makeDefaultBiodata();
    //   vm.showDetail = false;
    //   vm.selectPlayer = null;
    // });

    vm.showDetail = false;
    vm.healthDataList();


  };

  vm.rowClick = function (obj) {

    vm.showDetail = true;
    vm.selectPlayer = obj;


    var params = {
      'user_id': obj.user_id,
      // day: $scope.$parent.base.commonData.date
      day: '2017.09.19'
    }
    BioService.userDataAll(params).then(function (res) {

      console.log('userDataAll', res);
      // console.log(angular.copy(res))

      // if (typeof res !== 'string') {

      //   for (var i in res) {
      //     if (res[i] == '') {
      //       res[i] = null;
      //     } else {
      //       if (i != 'day' && i != 'sleep_target' && i != 'sleep_time') {
      //         res[i] = Number(res[i]);
      //       }
      //     }
      //   }

      //   var copyObj = angular.copy(res);
      //   angular.extend(vm.selectBioData, res, {});

      //   // 목표 수면시간
      //   if (copyObj.sleep_target && copyObj.sleep_target != '') {
      //     vm.selectBioData['sleep_target'] = {
      //       hour: copyObj.sleep_target.split(':')[0],
      //       minute: copyObj.sleep_target.split(':')[1]
      //     }
      //   } else {
      //     vm.selectBioData['sleep_target'] = {
      //       hour: null,
      //       minute: null
      //     }
      //   }

      //   // 실제 수면시간
      //   if (copyObj.sleep_time && copyObj.sleep_time != '') {
      //     vm.selectBioData['sleep_time'] = {
      //       hour: copyObj.sleep_time.split(':')[0],
      //       minute: copyObj.sleep_time.split(':')[1]
      //     }
      //   } else {
      //     vm.selectBioData['sleep_time'] = {
      //       hour: null,
      //       minute: null
      //     }
      //   }


      //   // 소변상태
      //   vm.selectBioData['urine_3'] = {
      //     list: vm.selectBioDataUrine_3List,
      //     selected: copyObj.urine_3 ? _.find(vm.selectBioDataUrine_3List, { value: copyObj.urine_3 }) : null
      //   }

      // } else {
      //   vm.selectBioData = vm.makeDefaultBiodata();
      // }
      // console.log(vm.selectBioData);


    });
    // console.log(obj);
  };




  // //현재 page명 세팅
  // $scope.$parent.base.pageStatus = 'teamRecordEtc';
  // /**
  //  * API 호출 시 parameter 로 사용할 변수
  //  */
  // vm.userInputData = $scope.$parent.base.bioInputData;
  // vm.setTargetData = $scope.$parent.base.bioTargetData;
  // vm.setPlayer = $scope.$parent.setPlayer;


  // // 소변상태 목록
  // vm.selectBioDataUrine_3List = [{value:1,state:'거품'},{value:2,state:'독한냄새'},{value:3,state:'혼탁'},{value:4,state:'검붉은색'},{value:5,state:'붉은색'}];
  // vm.makeDefaultBiodata = function(){
  //   return {
  //     day : '', // 조회날짜
  //     'weight_target' : null, //목표체중
  //     weight : null, //실제체중
  //     'sleep_target' : {
  //       hour : null,
  //       minute : null
  //     }, //목표수면
  //     'sleep_time' : {
  //       hour : null,
  //       minute : null
  //     }, //실제수면
  //     'water_target' : null, //목표수분
  //     'water_get' : null, //섭취수분
  //     'calrorie_target' : null, //목표칼로리
  //     'calrorie_get' : null, //섭취칼로리
  //     'calrorie_burned_target' : null, // 목표 칼로리 소모
  //     'calrorie_burned' : null, // 소모 칼로리
  //     'blood_pressure_1' : null, // 수축혈압
  //     'blood_pressure_2' : null, //이완혈압
  //     'blood_sugar_1' : null, // 공복혈당
  //     'blood_sugar_2' : null, // 식후혈당
  //     'urine_1' : null, // 소변호르몬
  //     'urine_2' : null, // 소변횟수
  //     'urine_3' : {
  //       list : vm.selectBioDataUrine_3List,
  //       selected : null
  //     }, //소변상태
  //     'lung_capacity_1' : null, // 호흡량
  //     'lung_capacity_2' : null, // 흡기량
  //     'lung_capacity_3' : null, // 호기량
  //     LA : null, // 젖산
  //     'LA_stable' : null, // 젖산 안정값
  //     OS : null, // 산소포화도
  //     'OS_stable' : null, // 산소포화도 안정값
  //     BT : null, // 체온
  //     'BT_stable' : null, // 체온 안정값
  //     SW : null, // 땀
  //     'SW_stable' : null, // 땀 안정값
  //     DS : null, // 거리
  //     'DS_stable' : null, // 거리 안정값
  //     VL : null, // 속도
  //     'VL_stable' : null // 속도 안정값
  //     // breakfast : null,
  //     // lunch : null,
  //     // dinner : null,
  //     // 'morning_snack' : null,
  //     // 'afternoon_snack' : null,
  //     // 'night_snack' : null,
  //     // 'breakfast_burned' : null,
  //     // 'lunch_burned' : null,
  //     // 'dinner_burned' : null,
  //     // 'morning_snack_burned' : null,
  //     // 'afternoon_snack_burned' : null,
  //     // 'night_snack_burned' : null,
  //     // 'down_time' : null, //취침시각
  //     // 'up_time' : null, //기상시각
  //   }
  // }

  // vm.selectBioData = vm.makeDefaultBiodata();

  // /**
  //  * 동작 기능
  //  */
  // // 기록
  // vm.record = function() {
  //   if(!(vm.selectPlayer)){
  //     toastr.error('선수가 선택되지 않았습니다.');
  //     return;
  //   };

  //   var userInput = BioService.userInput;
  //   var setTarget = BioService.setTarget;
  //   var deviceInput = BioService.deviceInput;

  //   // 거리
  //   (function(type) {
  //     var deviceInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type
  //     };

  //     deviceInputParams['value'] = vm.selectBioData.DS;
  //     deviceInputParams['stable'] = vm.selectBioData.DS_stable;
  //     deviceInput(deviceInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         //toastr.success('저장되었습니다.');
  //       }
  //     });
  //   })('DS');

  //   // 속도
  //   (function(type) {
  //     var deviceInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type
  //     };

  //     deviceInputParams['value'] = vm.selectBioData.VL;
  //     deviceInputParams['stable'] = vm.selectBioData.VL_stable;
  //     deviceInput(deviceInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         //toastr.success('저장되었습니다.');
  //       }
  //     });
  //   })('VL');

  //   // 칼로리소모
  //   (function(type) {
  //     // 생체 정보 입력
  //     var userInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       day: $scope.$parent.base.commonData.date,
  //       order: 1
  //     };
  //     var setTargetParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       value: null
  //     };

  //     userInputParams['value'] = vm.selectBioData.calrorie_burned;
  //     userInput(userInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         console.log('칼로리저장.');
  //         setTargetParams['value'] = vm.selectBioData.calrorie_burned_target;
  //         setTarget(setTargetParams).then(function(res2){
  //           if(res2 && res2.result == 'SUC'){
  //             //toastr.success('저장되었습니다.')
  //           }
  //         });
  //       }
  //     });
  //   })('CB');

  //   // 칼로리섭취
  //   (function(type) {
  //     // 생체 정보 입력
  //     var userInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       day: $scope.$parent.base.commonData.date,
  //       order: 1
  //     };
  //     var setTargetParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       value: null
  //     };

  //     userInputParams['value'] = vm.selectBioData.calrorie_get;
  //     userInput(userInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         console.log('칼로리저장.');
  //         setTargetParams['value'] = vm.selectBioData.calrorie_target;
  //         setTarget(setTargetParams).then(function(res2){
  //           if(res2 && res2.result == 'SUC'){
  //             //toastr.success('저장되었습니다.')
  //           }
  //         });
  //       }
  //     });
  //   })('CL');

  //   // 수분
  //   (function(type) {
  //     // 생체 정보 입력
  //     var userInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       day: $scope.$parent.base.commonData.date
  //     };
  //     var setTargetParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       value: null
  //     };

  //     userInputParams['value'] = vm.selectBioData.water_get;
  //     userInput(userInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         console.log('수분저장.');
  //         setTargetParams['value'] = vm.selectBioData.water_target;
  //         setTarget(setTargetParams).then(function(res2){
  //           if(res2 && res2.result == 'SUC'){
  //             //toastr.success('저장되었습니다.')
  //           }
  //         });
  //       }
  //     });
  //   })('WT');

  //   // 수면
  //   (function(type) {
  //     // 생체 정보 입력
  //     var userInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       day: $scope.$parent.base.commonData.date
  //     };
  //     var setTargetParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       value: null
  //     };

  //     userInputParams['value'] = vm.selectBioData.sleep_time.hour+':'+vm.selectBioData.sleep_time.minute;
  //     userInput(userInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         console.log('실제수면저장.');
  //         setTargetParams['value'] = vm.selectBioData.sleep_target.hour+':'+vm.selectBioData.sleep_target.minute;
  //         setTarget(setTargetParams).then(function(res2){
  //           if(res2 && res2.result == 'SUC'){
  //             //toastr.success('저장되었습니다.')
  //           }
  //         });
  //       }
  //     });
  //   })('ST');

  //   // 체중
  //   (function(type) {
  //     // 생체 정보 입력
  //     var userInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       day: $scope.$parent.base.commonData.date
  //     };
  //     var setTargetParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       value: null
  //     };

  //     userInputParams['value'] = vm.selectBioData.weight;
  //     userInput(userInputParams).then(function(res){
  //       console.log(res);
  //       if(res && res.result == 'SUC'){
  //         console.log('실제체중저장.');
  //         setTargetParams['value'] = vm.selectBioData.weight_target;
  //         setTarget(setTargetParams).then(function(res2){
  //           if(res2 && res2.result == 'SUC'){
  //             toastr.success('저장되었습니다.')
  //           }
  //         });
  //       }
  //     });
  //   })('BW');













  //   // 심박수
  //   (function(type) {
  //     var deviceInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type
  //     };

  //     deviceInputParams['value'] = vm.selectBioData.HB;
  //     deviceInputParams['stable'] = vm.selectBioData.HB_stable;
  //     console.log(deviceInputParams);
  //     deviceInput(deviceInputParams).then(function(res){
  //       console.log(res);
  //       if(res && res.result == 'SUC'){
  //         //toastr.success('저장되었습니다.');
  //       }
  //     });
  //   })('HB');

  //   // 젖산
  //   (function(type) {
  //     var deviceInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type
  //     };

  //     deviceInputParams['value'] = vm.selectBioData.LA;
  //     deviceInputParams['stable'] = vm.selectBioData.LA_stable;
  //     deviceInput(deviceInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         //toastr.success('저장되었습니다.');
  //       }
  //     });
  //   })('LA');

  //   // 산소포화도
  //   (function(type) {
  //     var deviceInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type
  //     };

  //     deviceInputParams['value'] = vm.selectBioData.OS;
  //     deviceInputParams['stable'] = vm.selectBioData.OS_stable;
  //     deviceInput(deviceInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         //toastr.success('저장되었습니다.');
  //       }
  //     });
  //   })('OS');

  //   // 체온
  //   (function(type) {
  //     var deviceInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type
  //     };

  //     deviceInputParams['value'] = vm.selectBioData.BT;
  //     deviceInputParams['stable'] = vm.selectBioData.BT_stable;
  //     deviceInput(deviceInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         //toastr.success('저장되었습니다.');
  //       }
  //     });
  //   })('BT');

  //   // 호흡
  //   (function(type) {
  //     // 생체 정보 입력
  //     var userInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       day: $scope.$parent.base.commonData.date
  //     };

  //     userInputParams['value'] = vm.selectBioData.lung_capacity_1;
  //     userInputParams['value2'] = vm.selectBioData.lung_capacity_2;
  //     userInputParams['value3'] = vm.selectBioData.lung_capacity_3;
  //     userInput(userInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         //toastr.success('저장되었습니다.');
  //       }
  //     });
  //   })('LC');

  //   // 혈압
  //   (function(type) {
  //     // 생체 정보 입력
  //     var userInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       day: $scope.$parent.base.commonData.date
  //     };

  //     userInputParams['value'] = vm.selectBioData.blood_pressure_1;
  //     userInputParams['value2'] = vm.selectBioData.blood_pressure_2;
  //     userInput(userInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         //toastr.success('저장되었습니다.');
  //       }
  //     });
  //   })('BP');

  //   // 혈당
  //   (function(type) {
  //     // 생체 정보 입력
  //     var userInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       day: $scope.$parent.base.commonData.date
  //     };

  //     userInputParams['value'] = vm.selectBioData.blood_sugar_1;
  //     userInputParams['value2'] = vm.selectBioData.blood_sugar_2;
  //     userInput(userInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         //toastr.success('저장되었습니다.');
  //       }
  //     });
  //   })('BS');

  //   // 소변
  //   (function(type) {
  //     // 생체 정보 입력
  //     var userInputParams = {
  //       'user_id': vm.selectPlayer.user_id,
  //       type: type,
  //       day: $scope.$parent.base.commonData.date
  //     };

  //     userInputParams['value'] = vm.selectBioData.urine_1;
  //     userInputParams['value2'] = vm.selectBioData.urine_2;
  //     userInputParams['value3'] = vm.selectBioData.urine_3.selected ? vm.selectBioData.urine_3.selected.value : null;
  //     userInput(userInputParams).then(function(res){
  //       if(res && res.result == 'SUC'){
  //         //toastr.success('저장되었습니다.');
  //       }
  //     });
  //   })('UR');
  // };

  // // 수정
  // vm.update = function() {

  // };

  // vm.inputNumberAdd = function(_d, unit){
  //   return ((_d && _d !='') ? Number(_d) : 0) + unit;
  // };

  // vm.inputNumberMinus = function(_d, unit){
  //   return ((_d && _d !='') ? Number(_d) : 0) - unit;
  // };






}

export default {
  name: 'RecordEtcCtrl',
  fn: RecordEtcCtrl
};
